import React from "react";
import { ConfigProvider, Menu } from "antd";
import "./AdminMenu.css";
import { useMenuItems } from "./useMenuItems";

export function AdminMenu(props) {
  const { className = "" } = props;
  const { items, current, onClick } = useMenuItems();

  return (
    <nav className={`admin-menu-nav ${className}`} aria-label="Main navigation">
      <ConfigProvider
        theme={{
          components: {
            Menu: {
              itemColor: "var(--text-secondary)",
              itemHoverColor: "var(--brand-primary)",
              itemSelectedColor: "var(--brand-primary)",

              itemBg: "transparent",
              itemHoverBg: "var(--brand-glow)",
              itemSelectedBg: "var(--brand-glow)",

              itemBorderRadius: 8,
              itemHeight: 40,
            },
          },
        }}
      >
        <Menu
          className="menu"
          mode="horizontal"
          onClick={onClick}
          selectedKeys={[current]}
          items={items}
          overflowedIndicator={<span className="admin-menu__overflow">More</span>}
          overflowedIndicatorPopupClassName="admin-menu__overflow-popup"
        ></Menu>
      </ConfigProvider>
    </nav>
  );
}
